const footerMenuList = [
  {
    id: 1,
    title: "Registry",
    diffClass: "md:col-start-7",
    list: [
      {
        id: 1,
        href: "/collection/explore_collection",
        text: "All Projects",
      },
      {
        id: 2,
        href: "/pledges",
        text: "Pledges",
      },
      {
        id: 3,
        href: "/activity",
        text: "Transactions",
      }
    ],
  },
  {
    id: 2,
    title: "Company",
    diffClass: "",
    list: [
      {
        id: 1,
        href: "https://www.carbonpump.com.au/methodologies",
        text: "Methodologies",
      },
      {
        id: 2,
        href: "https://www.carbonpump.com.au/about",
        text: "About",
      },
      {
        id: 3,
        href: "https://www.carbonpump.com.au/why-cadrs",
        text: "Why CADRs?",
      }
    ],
  },
  {
    id: 3,
    title: "My Account",
    diffClass: "",
    list: [
      {
        id: 1,
        href: "/user/avatar_6",
        text: "My Profile",
      }
    ],
  },
];

const socialIcons = [
  {
    id: 1,
    href: "https://www.facebook.com",
    text: "facebook",
  },
  {
    id: 2,
    href: "https://www.twitter.com",
    text: "twitter",
  },
  {
    id: 3,
    href: "https://www.discord.com",
    text: "discord",
  },
  {
    id: 4,
    href: "https://www.instagram.com",
    text: "instagram",
  },
  {
    id: 5,
    href: "https://www.tiktok.com",
    text: "tiktok",
  },
];

export { footerMenuList, socialIcons };
